/**
 *  @since: 2020-05-19
 *  @author: tams_dev1
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtSmtpForbiddenCmdListUrl: '/api/op/as/smtp-command/profiles',
  txtSmtpForbiddenCmdListCommitUrl: '/api/op/as-smtp-command-profiles',
  // 선택한 row 데이터
  rowSelectItems: {},
  getSmtpForbiddenCmdListData: []
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.getSmtpForbiddenCmdListData = []
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  getSmtpForbiddenCmdListDataAction: (state, data) => {
    state.getSmtpForbiddenCmdListData = _.cloneDeep(data)
  },
  addSmtpForbiddenCmdDataAction: (state, data) => {
    state.getSmtpForbiddenCmdListData.push(data)
  },
  editSmtpForbiddenCmdDataAction: (state, data) => {
    state.getSmtpForbiddenCmdListData = _.map(state.getSmtpForbiddenCmdListData, (item) => {
      if (item.smtp_ban_cmd_list_id === data.smtp_ban_cmd_list_id) {
        item.smtp_ban_cmd_list_uname = _.cloneDeep(data.smtp_ban_cmd_list_uname)
        item.smtp_ban_cmd_list_vrfy = _.cloneDeep(data.smtp_ban_cmd_list_vrfy)
        item.smtp_ban_cmd_list_expn = _.cloneDeep(data.smtp_ban_cmd_list_expn)
        item.smtp_ban_cmd_list_help = _.cloneDeep(data.smtp_ban_cmd_list_help)
        item.smtp_ban_cmd_list_turn = _.cloneDeep(data.smtp_ban_cmd_list_turn)
        item.smtp_ban_cmd_list_verb = _.cloneDeep(data.smtp_ban_cmd_list_verb)
        item.smtp_ban_cmd_list_etrn = _.cloneDeep(data.smtp_ban_cmd_list_etrn)
        item.smtp_ban_cmd_list_desc = _.cloneDeep(data.smtp_ban_cmd_list_desc)
      }
      return item
    })
  }
}

export const actions = {
  // SMTP 금지 명령어 조회
  async getSmtpForbiddenCmdListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtSmtpForbiddenCmdListUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSmtpForbiddenCmdListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // SMTP 금지 명령어 추가
  async addSmtpForbiddenCmdDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtSmtpForbiddenCmdListUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addSmtpForbiddenCmdDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // SMTP 금지 명령어 수정
  async editSmtpForbiddenCmdDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtSmtpForbiddenCmdListUrl}/${state.rowSelectItems[0].smtp_ban_cmd_list_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editSmtpForbiddenCmdDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // SMTP 금지 명령어 삭제
  async delSmtpForbiddenCmdDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'smtp_ban_cmd_list_id': item.smtp_ban_cmd_list_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtSmtpForbiddenCmdListUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtSmtpForbiddenCmdListUrl}/${state.rowSelectItems[0].smtp_ban_cmd_list_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  //  SMTP 금지 명령어 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtSmtpForbiddenCmdListCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
